import PropTypes from 'prop-types';
import React from 'react';
import Immutable from 'immutable';
import { bindAll } from '@bibliocommons/utils-react';
import { bibShape } from '@bibliocommons/bc-prop-types';

import BasePauseHoldWorkflowView from './BasePauseHoldWorkflowView';

export class SinglePauseHoldWorkflowView extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handlePauseHolds(suspended) {
    const { accountId, holdId, messagingId, workflowId } = this.props;
    this.props.pauseHolds({
      accountId,
      messagingId,
      holdIds: [holdId],
      workflowId,
      suspended: {
        ...suspended,
        status: true
      }
    });
    this.props.handleClose();
  }

  render() {
    const {
      handleClose,
      accountId,
      holdId,
      bib,
      messagingId,
      isLoading,
      initialSuspendStartDate,
      initialSuspendEndDate,
      enableEndDate,
      enableStartDate
    } = this.props;

    return (
      <BasePauseHoldWorkflowView
        handleClose={handleClose}
        handleHoldPauseDate={this.handlePauseHolds}
        accountId={accountId}
        holdIds={Immutable.List.of(holdId)}
        initialSuspendEndDate={initialSuspendEndDate}
        initialSuspendStartDate={initialSuspendStartDate}
        isLoading={isLoading}
        bibs={Immutable.List.of(bib)}
        enableEndDate={enableEndDate}
        enableStartDate={enableStartDate}
        messagingId={messagingId}
      />
    );
  }
}

SinglePauseHoldWorkflowView.propTypes = {
  handleClose: PropTypes.func.isRequired,
  pauseHolds: PropTypes.func.isRequired,
  accountId: PropTypes.number.isRequired,
  holdId: PropTypes.string,
  isLoading: PropTypes.bool,
  bib: bibShape.isRequired,
  messagingId: PropTypes.string,
  workflowId: PropTypes.string,
  initialSuspendStartDate: PropTypes.string,
  initialSuspendEndDate: PropTypes.string,
  enableStartDate: PropTypes.bool,
  enableEndDate: PropTypes.bool
};

export default SinglePauseHoldWorkflowView;
